import * as Yup from 'yup'

export const reviseInitialValues = {
    revisedText: '',
}

export const reviseValidationSchema = Yup.object().shape({
    revisedText: Yup.string()
        .required('Revised details are required')
        .max(255, 'Revise reason too long (maximum 255 characters)'),
})

export const approveInitialValues = {
    signature: '',
    poNumber: '',
}

export const approveValidationSchema = Yup.object().shape({
    signature: Yup.string()
        .required('Signature is required')
        .max(100, 'Signature too long (maximum 100 characters)'),
    poNumber: Yup.string(),
})

export const declineInitialValues = {
    declineText: '',
}

export const declineValidationSchema = Yup.object().shape({
    declineText: Yup.string()
        .required('Decline reason is required')
        .max(255, 'Decline reason too long (maximum 255 characters)'),
})
